import PropTypes from "prop-types";
import CacheExtension from "../../StarterKit/Filter/CacheExtension";
import React, {useEffect, useState,} from "react";
import ProductService from "../Services/Bll/ProductService";
import {IconActionButton} from "./IconActionButton";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import MediaService from "../../StarterKit/Service/Bll/MediaService";
import {SendToShopModal} from "./SendToShopModal";




export const ProductListModal = (props) => {
    const [data, setData] = useState(null);
    var productService = new ProductService()
    var mediaService = new MediaService()
    const [shops, setShops] = useState(null);
    const [open, setOpen] = useState(false)

    const CreateGuid = () => {
        function _p8(s) {
            var p = (Math.random().toString(16) + "000000000").substr(2, 8);
            return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
        }

        return _p8() + _p8(true) + _p8(true) + _p8();
    }

    var id = CreateGuid()

    const handleOpen = () => {
        productService.listFromModel(props.model).then(function (result) {
            setData(result.getData())
            setOpen(true);
        })
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <IconActionButton tooltip={CacheExtension.getDataFromCache('ProductListModal')} action={handleOpen} state={true} className={"btn modelDetails"} icon={<FontAwesomeIcon icon={props.icon} />}></IconActionButton>
            {open &&
                <div className="modal-container">
                    <div className="modal-overlay" onClick={handleClose}></div>
                    <div className="modal-dialog w-75" style={{maxWidth: "none", height: "90%"}}>
                        <div className="modal-content" style={{height: "100%"}}>
                            <div className="modal-header">
                                <h5 className="modal-title">{CacheExtension.getDataFromCache('ProductList')}</h5>
                                <button type="button" className="close" onClick={handleClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="fullSize modal-body model-modal">
                                <div className={'d-flex flex-column'}>
                                    <div className="text-left mb-2">{CacheExtension.getDataFromCache('Serial')}</div>
                                    { (data) ? (
                                        data.map( (index) =>
                                            <>
                                                <div className={'d-flex justify-content-between align-items-center'}>
                                                    <a>{index.serial}</a>
                                                    {/*<div className={'d-flex'}>*/}
                                                    {/*    <IconActionButton tooltip={CacheExtension.getDataFromCache('GetToken')}  action={async () => {*/}
                                                    {/*        await mediaService.read(index.token)*/}
                                                    {/*    }  } state={true} icon={<FontAwesomeIcon icon="fa-solid fa-file-pdf" />}></IconActionButton>*/}
                                                    {/*    <IconActionButton tooltip={CacheExtension.getDataFromCache('SellModal')} action={async () => {*/}
                                                    {/*        await productService.sell(index.key)*/}
                                                    {/*        window.location.reload()*/}
                                                    {/*    }  } state={true} icon={<FontAwesomeIcon icon="fa-solid fa-dollar-sign" />}></IconActionButton>*/}
                                                    {/*    <IconActionButton tooltip={CacheExtension.getDataFromCache('LostModal')} action={async () => {*/}
                                                    {/*        await productService.lost(index.key)*/}
                                                    {/*        window.location.reload()*/}
                                                    {/*    }  } state={true} icon={<FontAwesomeIcon icon="fa-solid fa-person-circle-question" />}></IconActionButton>*/}
                                                    {/*    <IconActionButton tooltip={CacheExtension.getDataFromCache('DestroyedModal')} action={async () => {*/}
                                                    {/*        await productService.destroyed(index.key)*/}
                                                    {/*        window.location.reload()*/}
                                                    {/*    }  } state={true} icon={<FontAwesomeIcon icon="fa-solid fa-heart-crack" />}></IconActionButton>*/}
                                                    {/*    <IconActionButton tooltip={CacheExtension.getDataFromCache('SavModal')} action={async () => await console.log('SAV ' + index.key)  } state={true} icon={<FontAwesomeIcon icon="fa-solid fa-wrench" />}></IconActionButton>*/}
                                                    {/*    <SendToShopModal  product={index.key} icon={<FontAwesomeIcon icon="fa-solid fa-truck-fast"></FontAwesomeIcon>}></SendToShopModal>*/}
                                                    {/*</div>*/}
                                                </div>
                                            </>
                                        )
                                    ) : ( ''
                                    )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

ProductListModal.propTypes = {
    model : PropTypes.string.isRequired,
    icon : PropTypes.string.isRequired,
}
